// @owners { team: patients }
import {
  AddOnsEndpoint,
  type AddOnsEndpointFetchByProductIdsRequest,
  type AddOnsEndpointFetchByProductIdsResponse,
} from '@alto/scriptdash/alto/patient_app/add_ons/v1/add_ons_endpoint';
import { createQueryKeys } from '@lukemorales/query-key-factory';
import { apiEndpointHandler } from '~shared/helpers/api';
import { getErrorMessageFromResponse } from '~shared/helpers/helper';

const addOnsEndpoint = AddOnsEndpoint(apiEndpointHandler);

export const addOns = createQueryKeys('addOns', {
  fetchByProductIDs: (params: AddOnsEndpointFetchByProductIdsRequest) => ({
    queryKey: [params],
    queryFn: async (): Promise<AddOnsEndpointFetchByProductIdsResponse> => {
      // this controller expects `product_ids[]=1&product_ids[]=2` rather than a comma joined string
      const response = await addOnsEndpoint.fetchByProductIDs(params, { splitArrayParams: true });
      if (response.errors?.length) {
        throw new Error(getErrorMessageFromResponse({ errors: response.errors }));
      }
      return response;
    },
  }),
});
